import { Routes } from '@angular/router';
import { AuthGuardService } from './services/auth/auth-guard.guard';

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: '/authenticated/welcome' },
  {
    path: 'authenticated',
    loadChildren: () =>
      import('./pages/authenticated/authenticated-routing.module').then((m) => m.routes),
    canActivate: [AuthGuardService],
    canLoad: [AuthGuardService],
  },
  {
    path: 'login',
    loadChildren: () =>
      import('./pages/login/login-routing.module').then((m) => m.routes),
  },
  {
    path: 'docs',
    loadChildren: () =>
      import('./pages/docs/docs-routing.module').then((m) => m.routes),
  },
  { path: '**', pathMatch: 'full', redirectTo: '/authenticated/welcome' }
];
